import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

const Container = styled.header`
  position: relative;

  display: flex;
  justify-content: space-between;
  align-items: center;

  height: 6.4rem;
  padding: 0 2.8rem;

  border-bottom: 0.1rem solid ${pickColor('borderColorDarkSecondary')};
  box-shadow: 0 4px 8px 0px rgba(0, 0, 0, 0.25);

  z-index: 10;

  button {
    font-weight: medium;
  }
`;

export { Container };
